module.exports = __webpack_public_path__ + "static/404-89acd855d042e4f0aa1fa6a43423fe81.svg";